/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Copied_To_ClipboardInputs */



/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Common_Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const common_copied_to_clipboard = /** @type {((inputs?: Common_Copied_To_ClipboardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Copied_To_ClipboardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In die Zwischenablage kopiert")
	return /** @type {LocalizedString} */ ("Copied to clipboard")
});